/* eslint-disable */
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AuthSimpleLayout from '../layouts/AuthSimpleLayout';
import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';

import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import SimpleLogin from 'components/authentication/simple/Login';
import SimpleLogout from 'components/authentication/simple/Logout';
import SimpleRegistration from 'components/authentication/simple/Registration';
import SimpleForgetPassword from 'components/authentication/simple/ForgetPassword';
import SimplePasswordReset from 'components/authentication/simple/PasswordReset';
import SimpleConfirmMail from 'components/authentication/simple/ConfirmMail';
import SimpleLockScreen from 'components/authentication/simple/LockScreen';

import SupportDesk from 'components/dashboards/support-desk';

//choosed
import TableView from 'components/app/support-desk/ticket/tickets/list_tickets/TableView';
import NewTicket from 'components/app/support-desk/ticket/NewTicket';
import NewTicketClient from 'components/app/support-desk/ticket/NewTicketClient';
import TicketsPreview from 'components/app/support-desk/tickets-preview/TicketsPreview';;
import ListUsers from 'components/app/support-desk/users/list/listUsers';
import AddUser from 'components/app/support-desk/users/AddUser';

import AddClient from '../components/app/support-desk/clients/AddClient';
import ListClients from 'components/app/support-desk/clients/list/listClients';
import EmailUnsubscribeConfirmation from 'components/pages/confirmations/EmailUnsubscribeConfirmation';
import UserProfile from 'components/app/support-desk/users/UserProfile';

const FalconRoutes = () => {
  return (
    <Routes>
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      {/*- ------------- Authentication ---------------------------  */}

      {/*- ------------- simple ---------------------------  */}
      <Route element={<AuthSimpleLayout />}>
        {/* choosed */}
        <Route path="authentication/simple/login" element={<SimpleLogin />} />
        <Route
          path="notification/email/unsubscribe/confirmation/:data"
          element={<EmailUnsubscribeConfirmation />}
        />

        <Route
          path="authentication/simple/register"
          element={<SimpleRegistration />}
        />
        <Route path="authentication/simple/logout" element={<SimpleLogout />} />
        <Route
          path="authentication/simple/forgot-password"
          element={<SimpleForgetPassword />}
        />
        <Route
          path="authentication/simple/reset-password"
          element={<SimplePasswordReset />}
        />
        <Route
          path="authentication/simple/confirm-mail"
          element={<SimpleConfirmMail />}
        />
        <Route
          path="authentication/simple/lock-screen"
          element={<SimpleLockScreen />}
        />
      </Route>

      <Route element={<MainLayout />}>
        {/* choosed */}
        {/* <Route path="/support-desk/table-view/:ts_id" element={<TableView />} /> */}
        <Route path="/support-desk/table-view" element={<TableView />} />
        <Route path="/support-desk/table-view/:ts_id/:isRecent" element={<TableView />} />
        {/* <Route path="/support-desk/table-view-client" element={<TableView_Client />} /> */}
        <Route path="/support-desk/new-ticket" element={<NewTicket />} />
        {/* <Route path="/support-desk/new-ticket-client" element={<NewTicketClient />} /> */}
        <Route path="/support-desk/list-users" element={<ListUsers />} />
        <Route
          path="/support-desk/add-user/:id/:saveType"
          element={<AddUser />}
        />
        <Route
          path="/support-desk/user-profile/:id"
          element={<UserProfile />}
        />
        <Route path="/support-desk/list-clients" element={<ListClients />} />
        <Route
          path="/support-desk/add-client/:id/:saveType"
          element={<AddClient />}
        />
        {/*Dashboard*/}
        <Route path="/" element={<SupportDesk />} />
        <Route
          path="/support-desk/tickets-preview/:id"
          element={<TicketsPreview />}
        />
        
      </Route>

      {/* //--- MainLayout end  */}

      {/* <Navigate to="/errors/404" /> */}
      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default FalconRoutes;
/* eslint-disable */